import React, { FC } from "react";
import styled from "styled-components";
import { rgba } from "polished";
import ArrowRight from "../../../icons/arrow-right";
import { useEditMode } from "../../../contexts/edit";

type Props = {
  onReorder: (direction: "up" | "down") => void;
  disabledState?: Partial<{ up: boolean; down: boolean }>;
};

export const OrderButtons: FC<Props> = ({ onReorder, disabledState }) => {
  const { editMode } = useEditMode();
  if (!editMode) return null;

  return (
    <ControlsWrapper>
      <button
        disabled={!!disabledState?.up}
        onClick={() => onReorder("up")}
        className="icon-button up"
      >
        <ArrowRight className="arrow-icon" />
      </button>
      <button
        disabled={!!disabledState?.down}
        onClick={() => onReorder("down")}
        className="icon-button down"
      >
        <ArrowRight className="arrow-icon" />
      </button>
    </ControlsWrapper>
  );
};

const ControlsWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;

  .up {
    transform: rotate(-90deg);
  }
  .down {
    transform: rotate(90deg);
  }

  .icon-button {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 24px;
    height: 24px;
    aspect-ratio: 1;
    border-radius: 50%;
    background-color: ${({ theme }) => rgba(theme.colors.primary, 0.1)};
    cursor: pointer;
    padding: 0;
    overflow: hidden;
    transition: background-color
      ${({ theme }) =>
        `${theme.transitions.duration} ${theme.transitions.type}`};

    &:disabled {
      opacity: 0.5;
      cursor: default;
      pointer-events: none;
    }

    &:hover {
      background-color: ${({ theme }) => rgba(theme.colors.primary, 0.3)};
    }

    &:focus,
    &:focus-within,
    &:focus-visible {
      outline: none;
    }
  }
`;
